export default [
  { label: 'Sensor', value: 'sensor' },
  { label: 'Gateway', value: 'gateway' },
]
